<!-- <chat-option-menu [parent]="this" [chat]="chat" *ngIf="isShowOptionMenu()">
</chat-option-menu> -->
<!-- <ion-toolbar> -->
<mat-toolbar class="background">
    <ion-grid>
        <ion-row class="ion-align-item-center">
            <!-- ---------------------col-1--------------------------- -->
            <ion-col class="ion-align-self-center" size="2">
                <ion-buttons start class="menuBtn">
                    <button class="icon-container" [hidden]="chatPage" *ngIf="showMenuBtn" (click)="showMenu()">
                        <ion-icon name='menu'></ion-icon>
                    </button>
                    <button class="icon-container" (click)="goBack()" *ngIf="showBackBtn">
                        <ion-icon name='arrow-back'></ion-icon>
                    </button>
                </ion-buttons>
            </ion-col>
            <!-- ---------------------col-2--------------------------- -->
            <ion-col class="ion-align-self-center" size="9">
        
                <div *ngIf="!searchInputVisible">
                    <ion-title style="padding-left: 7px;"
                        *ngIf="socketManager.connected && !isChatPage()" >
                        {{ titelTextInput }}
                    </ion-title>
                    <!-- <ion-title [hidden]="socketManager.connected"> {{socketManager.getMessage()}}</ion-title> -->
                    <ion-title  *ngIf="!isConnected()"> {{socketManager.getMessage()}}
                    </ion-title>

                </div>
                <!-- ---------------------search input DIV------------------------>
                <div *ngIf="searchInputVisible" class="search-col">
                    <ion-input class="search-input" *ngIf="isChatPage()" [value]="needle" [(ngModel)]="needle"
                        (input)="onInput($event)" placeholder="{{ 'HEADER.Search.placeHolderChat' | translate }}">
                        <!-- <ion-icon class="search-icon" name="search" (click)="searchInDatabase()">
                        </ion-icon> -->

                    </ion-input>

                    <ion-input class="search-input" *ngIf="!isChatPage()" [value]="needle" [(ngModel)]="needle"
                        (input)="onInput($event)" placeholder="{{ 'HEADER.Search.placeHolderItems' | translate }}">

                        <!-- <ion-icon name="search" class="search-icon"></ion-icon> -->

                    </ion-input>
                </div>
                <!-- ---------------------isQuiz DIV ------------------------>

                <div *ngIf="isQuiz()" [hidden]="searchInputVisible" id="points">
                    <span>{{ 'HEADER.ChatPage.points' | translate }}</span>
                    <span>{{userManager.user.points}}</span>
                </div>

            </ion-col>
            <!-- ---------------------col-3--------------------------- -->
            <ion-col class="ion-align-self-center" size="1">
                <ion-buttons *ngIf="hasSearchBtn()" class="searchButton">
                    <button class="icon-container" *ngIf="isChatPage() && !searchInputVisible" (click)="showChatOptionMenu()">
                        <ion-icon name="ellipsis-vertical"></ion-icon>
                    </button>
                    <button class="icon-container" *ngIf="!searchInputVisible && !isChatPage()" (click)="search()" >
                        <ion-icon name="search" side="right"></ion-icon>
                    </button>
                    <button class="icon-container" *ngIf="searchInputVisible" (click)="cancel()">
                        <ion-icon name="close"></ion-icon>
                    </button>
                </ion-buttons>
            </ion-col>

        </ion-row>
    </ion-grid>
</mat-toolbar>
